import React from 'react';
import './TermsOfService.css';

function TermsOfService() {
  return (
    <div className="terms-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Terms of Service</h1>
          <p>Last Updated: February 9, 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="section policy-content">
        <div className="container">
          <div className="policy-inner">
            
            <div className="policy-section">
              <h2>1. Agreement to Terms</h2>
              <p>
                These Terms of Service ("Terms") constitute a legally binding agreement between you and Future Labs 
                ("Company", "we", "us", or "our") concerning your access to and use of our website and services.
              </p>
              <p>
                By accessing or using our services, you agree to be bound by these Terms. If you do not agree with 
                any part of these Terms, you must not access or use our services.
              </p>
            </div>

            <div className="policy-section">
              <h2>2. Services Description</h2>
              <p>
                Future Labs provides technology consulting, software development, web development, mobile app development, 
                and related digital services. We reserve the right to modify, suspend, or discontinue any aspect of our 
                services at any time without prior notice.
              </p>
            </div>

            <div className="policy-section">
              <h2>3. User Eligibility</h2>
              <p>
                By using our services, you represent and warrant that:
              </p>
              <ul>
                <li>You are at least 18 years of age</li>
                <li>You have the legal capacity to enter into binding contracts</li>
                <li>You are not prohibited from using our services under applicable law</li>
                <li>All information you provide is accurate, current, and complete</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>4. User Accounts</h2>
              <h3>4.1 Account Creation</h3>
              <p>
                To access certain features of our services, you may need to create an account. You agree to:
              </p>
              <ul>
                <li>Provide accurate and complete registration information</li>
                <li>Maintain and promptly update your account information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Accept responsibility for all activities under your account</li>
                <li>Notify us immediately of any unauthorized access</li>
              </ul>

              <h3>4.2 Account Termination</h3>
              <p>
                We reserve the right to suspend or terminate your account at any time, with or without notice, 
                for any reason, including violation of these Terms.
              </p>
            </div>

            <div className="policy-section">
              <h2>5. Acceptable Use Policy</h2>
              <p>
                You agree not to use our services to:
              </p>
              <ul>
                <li>Violate any applicable laws, regulations, or third-party rights</li>
                <li>Transmit harmful, threatening, abusive, or defamatory content</li>
                <li>Impersonate any person or entity</li>
                <li>Interfere with or disrupt the integrity or performance of our services</li>
                <li>Attempt to gain unauthorized access to our systems or networks</li>
                <li>Distribute viruses, malware, or other malicious code</li>
                <li>Engage in any form of automated data collection or scraping</li>
                <li>Use our services for spam or unsolicited communications</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>6. Intellectual Property Rights</h2>
              <h3>6.1 Our Property</h3>
              <p>
                All content, features, and functionality of our website and services, including but not limited to 
                text, graphics, logos, images, software, and design, are owned by Future Labs or its licensors and 
                are protected by copyright, trademark, and other intellectual property laws.
              </p>

              <h3>6.2 Limited License</h3>
              <p>
                We grant you a limited, non-exclusive, non-transferable, revocable license to access and use our 
                services for your personal or internal business purposes, subject to these Terms.
              </p>

              <h3>6.3 User Content</h3>
              <p>
                You retain ownership of any content you submit to our services. By submitting content, you grant us 
                a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and display such content 
                in connection with providing our services.
              </p>
            </div>

            <div className="policy-section">
              <h2>7. Payment Terms</h2>
              <p>
                If you purchase services from us:
              </p>
              <ul>
                <li>You agree to pay all fees as specified in your service agreement</li>
                <li>All fees are non-refundable unless otherwise stated</li>
                <li>We reserve the right to change our fees with reasonable notice</li>
                <li>You are responsible for all taxes associated with your purchase</li>
                <li>Late payments may result in suspension of services</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>8. Service Level and Availability</h2>
              <p>
                While we strive to provide continuous service availability, we do not guarantee that our services 
                will be uninterrupted, timely, secure, or error-free. We reserve the right to perform maintenance 
                and updates that may temporarily affect service availability.
              </p>
            </div>

            <div className="policy-section">
              <h2>9. Third-Party Services and Links</h2>
              <p>
                Our services may contain links to third-party websites or services that are not owned or controlled 
                by Future Labs. We have no control over and assume no responsibility for the content, privacy policies, 
                or practices of any third-party websites or services.
              </p>
            </div>

            <div className="policy-section">
              <h2>10. Disclaimer of Warranties</h2>
              <p>
                OUR SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS 
                OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, 
                OR NON-INFRINGEMENT.
              </p>
            </div>

            <div className="policy-section">
              <h2>11. Limitation of Liability</h2>
              <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, FUTURE LABS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, 
                SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED 
                DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
              </p>
            </div>

            <div className="policy-section">
              <h2>12. Indemnification</h2>
              <p>
                You agree to indemnify, defend, and hold harmless Future Labs and its officers, directors, employees, 
                and agents from any claims, liabilities, damages, losses, and expenses arising out of or in any way 
                connected with your access to or use of our services or your violation of these Terms.
              </p>
            </div>

            <div className="policy-section">
              <h2>13. Confidentiality</h2>
              <p>
                Both parties agree to maintain the confidentiality of any proprietary or confidential information 
                disclosed during the course of the business relationship, unless required by law or with prior 
                written consent.
              </p>
            </div>

            <div className="policy-section">
              <h2>14. Dispute Resolution</h2>
              <h3>14.1 Governing Law</h3>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of India, without regard 
                to its conflict of law provisions.
              </p>

              <h3>14.2 Arbitration</h3>
              <p>
                Any disputes arising out of or relating to these Terms shall be resolved through binding arbitration 
                in Bangalore, Karnataka, India, in accordance with the Arbitration and Conciliation Act, 1996.
              </p>
            </div>

            <div className="policy-section">
              <h2>15. Modifications to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. We will notify users of any material changes 
                by posting the new Terms on our website and updating the "Last Updated" date. Your continued use of 
                our services after such modifications constitutes your acceptance of the updated Terms.
              </p>
            </div>

            <div className="policy-section">
              <h2>16. Severability</h2>
              <p>
                If any provision of these Terms is found to be unenforceable or invalid, that provision shall be 
                limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain 
                in full force and effect.
              </p>
            </div>

            <div className="policy-section">
              <h2>17. Entire Agreement</h2>
              <p>
                These Terms constitute the entire agreement between you and Future Labs regarding the use of our 
                services and supersede all prior agreements and understandings.
              </p>
            </div>

            <div className="policy-section">
              <h2>18. Contact Information</h2>
              <p>
                If you have any questions about these Terms, please contact us at:
              </p>
              <ul className="contact-info">
                <li><strong>Email:</strong> legal@futurelabs.com</li>
                <li><strong>Phone:</strong> +91 80 1234 5678</li>
                <li><strong>Address:</strong> Future Labs, Bangalore, Karnataka, India</li>
              </ul>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default TermsOfService;
